import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MessagesPanel from '../components/MessagesPanel';
import SEO from '../components/SEO';

const MessagesPage = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-[#09090B] py-8 px-4 sm:px-6 lg:px-8">
      <SEO title="Messages | DojoDash" description="Message your coach or client directly inside DojoDash." />
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold text-white mb-6">Messages</h1>
        <MessagesPanel />
      </div>
    </div>
  );
};

export default MessagesPage;
